import { useWorkspaceContext } from '@/contexts/WorkspaceContext';
import { useProfile } from '@/hooks/useProfile';
import { supabase } from '@/integrations/supabase/client';
import { useEffect, useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { AlertTriangle } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';
import { Link } from 'react-router-dom';

export function WelcomeHeader() {
  const { activeWorkspace } = useWorkspaceContext();
  const { profile, loading: profileLoading } = useProfile();
  const [urgentCount, setUrgentCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!activeWorkspace?.id) {
      setLoading(false);
      return;
    }

    const fetchUrgentTickets = async () => {
      try {
        const { count } = await supabase
          .from('tickets')
          .select('*', { count: 'exact', head: true })
          .eq('workspace_id', activeWorkspace.id)
          .eq('priority', 'high')
          .is('assigned_to', null)
          .in('status', ['new', 'open']);

        setUrgentCount(count || 0);
      } catch (error) {
        console.error("Failed to fetch urgent tickets:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUrgentTickets();
  }, [activeWorkspace?.id]);

  if (loading || profileLoading) {
    return (
      <div>
        <Skeleton className="h-6 w-48" />
      </div>
    );
  }

  if (urgentCount === 0) {
    return null;
  }

  return (
    <Link to="/tickets?priority=high&assigned=unassigned">
      <Badge 
        variant="destructive" 
        className="flex items-center gap-1.5 px-3 py-1.5 cursor-pointer hover:bg-destructive/90 w-fit"
      >
        <AlertTriangle className="h-3.5 w-3.5" />
        <span>{urgentCount} ticket{urgentCount > 1 ? 's' : ''} urgent{urgentCount > 1 ? 's' : ''} non assigné{urgentCount > 1 ? 's' : ''}</span>
      </Badge>
    </Link>
  );
}
